import type { FavoritesConfig } from '#types/config/components/favorites'
import type { RecursivePartial } from '#types/utils'

export default {
  buttonVariants: {
    createAccount: 'secondary'
  },
  dialogOptions: { type: 'modal' },
  list: {
    brandClasses: {
      title: 'title-2'
    },
    productsPerPage: 48
  },
  unauthenticatedCtaPosition: 'header'
} satisfies RecursivePartial<FavoritesConfig>
